import Loader from '@/components/common/Loader';
import { Suspense } from 'react';
import ReviewContent from '../components/review/ReviewContent';

export default function TemplateReviewPage() {
  return (
    <Suspense fallback={<Loader />}>
      <ReviewContent />
    </Suspense>
  );
}
